import appLayout from '../layouts/AppLayout.vue'
export default [
  // USER
  {
    path: '/whitelabels/',
    name: 'whitelabels-list',
    component: () => import('../views/whitelabels/WhitelabelsIndex.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/whitelabels/create',
    name: 'whitelabels-create',
    component: () => import('../views/whitelabels/WhitelabelCreate.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/whitelabels/:id?',
    name: 'whitelabels-edit',
    component: () => import('../views/whitelabels/WhitelabelEdit.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/whitelabel/:id?/payments',
    name: 'whitelabels-payment',
    component: () => import('../views/whitelabels/WhitelabelPayment.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/whitelabel/:id?/customize',
    name: 'whitelabels-customize',
    component: () => import('../views/whitelabels/WhitelabelCustomizeForm.vue'),
    meta: { layout: appLayout }
  }
]
